export const GIA_FLOW_KNOWLEDGE = {
  purchaseToStock: {
    key: 'purchaseToStock',
    label: 'Compra a stock',
    summary: 'Una compra entra a Stock con cantidad y costo, y desde ahí queda lista para usarse en la operación.',
    steps: [
      'Cargar compra con producto, proveedor, cantidad y costo.',
      'Confirmar que la compra impacte como ingreso y quede visible en stock.',
      'Dejar base comercial preparada si después va a salida manual o pedido.',
    ],
  },
  outboundOrder: {
    key: 'outboundOrder',
    label: 'Preparación de salida',
    summary: 'La salida se prepara en Stock. Después Logística la toma y recién ahí pasa a ruta.',
    steps: [
      'Preparar pedido completo o parcial.',
      'Esperar que logística lo tome como pendiente válido.',
      'Asignarlo a destino, unidad y carga operativa sin duplicaciones.',
    ],
  },
  routeLifecycle: {
    key: 'routeLifecycle',
    label: 'Ciclo de ruta',
    summary: 'Una ruta pasa por preparación, tránsito y cierre. Al completarse, deja historia y sale del espacio de trabajo activo.',
    steps: [
      'Crear ruta con unidad y destinos.',
      'Marcar estados en viaje.',
      'Cerrar entregas o retiros para sacar la operación del pendiente activo.',
    ],
  },
  warrantyCycle: {
    key: 'warrantyCycle',
    label: 'Ciclo de garantía',
    summary: 'Garantía saca el producto del stock disponible, lo lleva a un estado aparte y después define cómo vuelve o cómo se cierra.',
    steps: [
      'Preparar salida por garantía.',
      'Tomar esa salida en logística como flujo específico.',
      'Registrar regreso o resolución final para cerrar la historia.',
    ],
  },
  physicalControl: {
    key: 'physicalControl',
    label: 'Control físico',
    summary: 'Control físico compara lo que dice el sistema con lo que realmente hay en depósito.',
    steps: [
      'Leer las cantidades del sistema por producto.',
      'Compararlas con el conteo real.',
      'Registrar la diferencia y dejar el ajuste documentado.',
    ],
  },
};

export default GIA_FLOW_KNOWLEDGE;
